module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/576a1103506ec80bd274c7bc5f586a7e.png";